import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
// import { Helmet } from 'react-helmet';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BASE_URL } from '../../config';
import { getAboutData } from '../../Redux/ActionCreater';
import AboutContainer from './AboutContainer'

function AboutUs() {
    const [about,setAbout]=useState();
    const [loading,setLoading]=useState(true);
    const dispatch = useDispatch();
    const state = useSelector(
      (state) => (
         state.dataReducer
      ),
      shallowEqual
    );
    useEffect(() => {
        // $('.lazy').Lazy();
        fetchData()
      }, [])
    
     
      const fetchData = async () => {
      
        let header={
          headers:{
          "X-Auth-Token":"12345"
        }};
        dispatch(getAboutData(header));
        
      };
      useEffect(() => {
        setAbout(state.aboutpageData);
        setLoading(state.isLoading)
        }, [state])
  return (
    <>
    {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
    <>
    <Helmet>
          <title>{`CNC Machine :: ${about?.page_title}`}</title>
          <meta name="description" content={about?.meta_description} />
          <meta name="keywords" content={about?.meta_keywords} />
          <meta name="title" content={about?.meta_title} />
          <meta property="og:title" content={`CNC Machine :: ${about?.page_title}`}/>
        </Helmet>
    <AboutContainer data={about}/>
    </>
}
    </>
  )
}

export default AboutUs